import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { agingIncomingInvoiceSubmitted } from "store/actions/incomingInvoiceActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { AgingIncomingInvoiceTodoFooterProps } from "models/propTypes/incomingInvoicePropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageFooter } from "components/common";
import AgingIncomingInvoiceMoreActions from "./agingIncomingInvoiceMoreActions";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AgingIncomingInvoiceFooter: React.FC<AgingIncomingInvoiceTodoFooterProps> = (props) => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const { type, agingInvoice, disableSuccessMessages, markAsDoneHandler } = props;
  const dispatch = useDispatch();

  const submitAgingInvoice = () => {
    return props.invoiceFormSubmitHandler((values) => {
      return incomingInvoiceService.onAgingInvoiceSubmit(
        incomingInvoiceService.getAgingInvoiceApiModel(type, agingInvoice.isQuestion, agingInvoice.id, values)
      );
    });
  };

  const onSubmitSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(agingIncomingInvoiceSubmitted(agingInvoice.id));
  };

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Accept),
          onClick: submitAgingInvoice,
          type: StyleEnums.DisplayType.Success,
          onActionSuccess: onSubmitSuccess,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SupplementaryMaterial.TodoSubmitSuccess
          ),
        },
      ]}
      moreActions={
        <AgingIncomingInvoiceMoreActions agingInvoice={agingInvoice} markAsDoneHandler={markAsDoneHandler} />
      }
      showNavigateBack={props.showNavigateBack}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default AgingIncomingInvoiceFooter;
